// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useEffect, useContext, useState} from 'react';
import {App_context} from 'hola_app_context';
import {get} from 'zutil';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_qs} from '../../../../hola/pub/lib/use_qs';

export const use_thank_you = ()=>{
    const qs = use_qs();
    const {user} = useContext(App_context);
    const [email, set_email] = useState(user ? get(user, 'emails.0.value')
        : decodeURIComponent(qs.email));
    const [last_resend, set_last_resend] = useState(0);
    const [resent, set_resent] = useState(false);
    const [time_error, set_time_error] = useState(false);
    const resend_email = ()=>{
        if (Date.now() - last_resend > 30000)
        {
            fetch('/users/payment/resend_pro_receipt'
                +(qs.order ? '?order='+qs.order : ''), {method: 'POST'});
            set_last_resend(Date.now());
            set_resent(true);
        }
        else
            set_time_error(true);
    };
    useEffect(()=>{
        if (user && get(user, 'emails.0.value'))
            set_email(get(user, 'emails.0.value'));
    }, [user]);
    return {user, resent, email, time_error, resend_email, set_resent,
        set_time_error};
};
